import PropTypes from 'prop-types'
import React, { Component , useContext} from 'react'
import { BrowserRouter, Route, Link } from 'react-router-dom';
// import  Carousel  from  'semantic-ui-carousel-react';
import firebase from 'firebase/app';
import {dbClicks, logObject} from '../firebase'
import { AppState } from '../context';

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
} from 'semantic-ui-react'

// const someContext = useContext(AppState);
//const [logged, setLogged] = useState(false);
// const {
//   clicks,
// } = someContext;
// Heads up!
// We using React Static to prerender our docs with server side rendering, this is a quite simple solution.
// For more advanced usage please check Responsive docs under the "Usage" section.
const getWidth = () => {
  const isSSR = typeof window === 'undefined'

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
}
function LogFirebase(){
  // var temp=clicks['getstarted']+1;
  // dbClicks.child('getstarted')

  logObject.logEvent("search");
}

/* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */

  
const HomepageHeading = ({ mobile }) => 
{
  // const  elements  = [
  //   {
  //     render:()=>{
  //       return (
  //         <Container text>
  //     <Header
  //       as='h1'
  //       content='Homecare'
  //       inverted
  //       style={{
  //         fontSize: mobile ? '2em' : '4em',
  //         fontWeight: 'normal',
  //         marginBottom: 0,
  //         marginTop: mobile ? '1.5em' : '3em',
  //       }}
  //     />
  //     <Header
  //       as='h2'
  //       content='Streamline communication for seamless care of your loved ones.'
  //       inverted
  //       style={{
  //         fontSize: mobile ? '1.3em' : '1.5em',
  //         fontWeight: 'normal',
  //         marginTop: mobile ? '0.5em' : '1.5em',
  //       }}
  //     />
  //     <Button primary size='huge' as={Link} to={'/signup'} >
  //       {/* onClick={()=>writeFirebase()} */}
  //       Get Started
  //       <Icon name='right arrow' />
  //     </Button>
  //     <Segment inverted>
  //       <Header
  //         as='h3'
  //         content='Sign in:'
  //         inverted
  //         style={{
  //           fontSize: mobile ? '1.3em' : '1.5em',
  //           fontWeight: 'normal',
  //           marginTop: mobile ? '0.5em' : '1.5em',
  //           marginBottom: mobile ? '-1.5em' : '0em',
  //         }}
  //       />
  //     </Segment>
  
  //     <Segment inverted>
  //       <Button as={Link} size='huge' to={'/login'} inverted style={{ marginBottom: "0.7em", marginRight: "0.5em" }}>
  //         Family Member
  //       </Button>
  
  //       {/* <Button as={Link} size='huge' to={'/viewfamily'} inverted style={{}}>
  //         Secondary Family Member
  //                   </Button> */}
  //       <Button as={Link} size='huge' to={'/caregivers'} inverted >
  //         {/* style={{ marginTop: '0.7em' }} */}
  //         Caregiver
  //                   </Button>
  //       {/* <br />
  //                   <Header
  //       as='h5'
  //       content=' Secondary family members are added by primary family members.'
  //       inverted
  //       style={{
  //         fontSize: mobile ? '1.3em' : '1.5em',
  //         fontWeight: 'normal',
  //         marginTop: mobile ? '0.5em' : '1.5em',
  //       }}
  //     /> */}
  //     </Segment>
  
  //   </Container>
  //       )
  //     }
  //   },
  //   {
  //     render:()=>{
  //       return <Button  fluid>2222222</Button>
  //     }
  //     },
  // ]
return (<div>
  <Container text>
    <Header
      as='h1'
      content='Homecare'
      inverted
      style={{
        fontSize: mobile ? '2em' : '4em',
        fontWeight: 'normal',
        marginBottom: 0,
        marginTop: mobile ? '1.5em' : '3em',
      }}
    />
    <Header
      as='h2'
      content='Streamline communication for seamless care of your loved ones.'
      inverted
      style={{
        fontSize: mobile ? '1.3em' : '1.5em',
        fontWeight: 'normal',
        marginTop: mobile ? '0.5em' : '1.5em',
      }}
    />
    <Button primary size='huge' as={Link} to={'/signup'} onClick={()=>LogFirebase()}>
      
      Get Started
      <Icon name='right arrow' />
    </Button>
    <Segment inverted>
      <Header
        as='h3'
        content='Sign in:'
        inverted
        style={{
          fontSize: mobile ? '1.3em' : '1.5em',
          fontWeight: 'normal',
          marginTop: mobile ? '0.5em' : '1.5em',
          marginBottom: mobile ? '-1.5em' : '0em',
        }}
      />
    </Segment>

    <Segment inverted>
      <Button as={Link} size='huge' to={'/login'} inverted style={{ marginBottom: "0.7em", marginRight: "0.5em" }}>
        Family Member
      </Button>

      {/* <Button as={Link} size='huge' to={'/viewfamily'} inverted style={{}}>
        Secondary Family Member
                  </Button> */}
      <Button as={Link} size='huge' to={'/caregivers'} inverted >
        {/* style={{ marginTop: '0.7em' }} */}
        Caregiver
                  </Button>
      {/* <br />
                  <Header
      as='h5'
      content=' Secondary family members are added by primary family members.'
      inverted
      style={{
        fontSize: mobile ? '1.3em' : '1.5em',
        fontWeight: 'normal',
        marginTop: mobile ? '0.5em' : '1.5em',
      }}
    /> */}
    </Segment>

  </Container>
  {/* <div>
  <Carousel
    elements  =  {  elements  }
    duration  ={3000}
    animation  ='slide left'
    showNextPrev  =  {false}
  />
</div> */}
</div>
)
  }

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
}

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {}

  hideFixedMenu = () => this.setState({ fixed: false })
  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { children } = this.props
    const { fixed } = this.state

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign='center'
            style={{ minHeight: 700, padding: '1em 0em' }}
            vertical
          >
            <Menu
              fixed={fixed ? 'top' : null}
              inverted={!fixed}
              pointing={!fixed}
              secondary={!fixed}
              size='large'
            >
              <Container>
                <Menu.Item href='/' fluid active>
                  Home
                </Menu.Item>
                <Menu.Item href='/blog' fluid>
                  Blog
                </Menu.Item>
                <Menu.Item href='/tutorial' fluid>
                  How It Works
                </Menu.Item>
                <Menu.Item href='/zipcoderesources' fluid>
                  COVID-19 resources
                </Menu.Item>
{/* 
                <Menu.Item href='/requestdemo' fluid>
                  Request Demo
                </Menu.Item> */}
                <Menu.Item href='/contactus' fluid>
                  Contact Us
                </Menu.Item>



                {/* <Menu.Item as='a'>Work</Menu.Item>
                <Menu.Item as='a'>Company</Menu.Item>
                <Menu.Item as='a'>Careers</Menu.Item> */}
                {/* <Menu.Item position='right'>
                  <Button as='a' inverted={!fixed}>
                    Log in primary family members
                  </Button>
                  <Button as='a' inverted={!fixed} primary={fixed} style={{ marginLeft: '0.5em' }}>
                    Log in secondary family members
                  </Button>
                  <Button as='a' inverted={!fixed} primary={fixed} style={{ marginLeft: '0.5em' }}>
                    Log in caregivers
                  </Button>
                </Menu.Item> */}
              </Container>
            </Menu>
            <HomepageHeading />
          </Segment>
        </Visibility>

        {children}
      </Responsive>
    )
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
}

class MobileContainer extends Component {
  state = {}

  handleSidebarHide = () => this.setState({ sidebarOpened: false })

  handleToggle = () => this.setState({ sidebarOpened: true })

  render() {
    const { children } = this.props
    const { sidebarOpened } = this.state

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation='push'
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item href='/' active>
            Home
          </Menu.Item>
          <Menu.Item href='/blog'>
            Blog
          </Menu.Item>
          <Menu.Item href='/tutorial' fluid>
                  How It Works
          </Menu.Item>
          <Menu.Item href='/zipcoderesources' fluid>
                  COVID-19 resources
          </Menu.Item>
          <Menu.Item href='/contactus' fluid>
                                                Contact Us
                </Menu.Item>
          <Menu.Item as={Link} to={'/login'}>Log in families</Menu.Item>
          <Menu.Item as={Link} to={'/caregivers'}>Log in caregiver</Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign='center'
            style={{ minHeight: 350, padding: '1em 0em' }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size='large'>
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name='sidebar' />
                </Menu.Item>
                {/* <Menu.Item position='right'>
                  <Button as='a' inverted>
                    Caregivers
                  </Button>
                  <Button as='a' inverted style={{ marginLeft: '0.5em' }}>
                    Family Members
                  </Button>
                  <Button as='a' inverted style={{ marginLeft: '0.5em' }}>
                    Family Members
                  </Button>
                </Menu.Item> */}
              </Menu>
            </Container>
            <HomepageHeading mobile />
          </Segment>

          {children}
        </Sidebar.Pusher>
      </Responsive>
    )
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
}

const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </div>
)

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
}

const Home = () => (
  <ResponsiveContainer>
    <Segment style={{ padding: '4em 0em' }} vertical>
      <Grid container >
        <Grid.Row>
          <Grid.Column width={14}>
            <Header as='h3' style={{ fontSize: '2em' }}>
              Our Mission
            </Header>
            <p style={{ fontSize: '1.33em' }}>
              We are the single stop destination for all those involved in taking care of a senior.
              Our app is customized for the caregiving and healthcare industry, making senior care a simple process by making everyone stay on
              the same page - both literally and figuratively.
            </p>
          </Grid.Column>
        </Grid.Row>

      </Grid>
    </Segment>
    {/* <Segment style={{ padding: '4em 0em' }} vertical>
    <Grid container >
       
        </Grid>
    </Segment> */}
    <Segment style={{ padding: '4em 0em' }} vertical>
      <Grid container >
        <Grid.Row>
          <Grid.Column width={16} >
            <Header as='h3' style={{ fontSize: '2em' }} >How does it work?
          </Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={14}>
            <Header as='h5' style={{ fontSize: '1.63em' }} >
              Daily Summary
          </Header>
            <p style={{ fontSize: '1.33em' }}>
              Track progress on the day's tasks: see what tasks were completed when, and remind via text by just a tap of a button for those tasks that are incomplete!
          </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Image src="Summary.png" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={14}>
            <Header as='h5' style={{ fontSize: '1.63em' }} >
              Your Tasklist
          </Header>
            <p style={{ fontSize: '1.33em' }}>
              See all the tasks a caregiver or any family members assign to you, and you add other family members to your Homecare account via the settings in the profile page.
          </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16} style={{ maxWidth: 450 }}>
            <Image src="Tasklist.png" />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    <Segment style={{ padding: '4em 0em' }} vertical>
      <Grid container >
        <Grid.Row>
          <Grid.Column width={14}>
            <Header as='h3' style={{ fontSize: '2em' }}>
              About us
            </Header>
            <p style={{ fontSize: '1.33em' }}>
              We are a Northwestern based start-up radically innovating the way we care.
            </p>
            <Header as='h3' style={{ fontSize: '2em' }}>
              Contact Us:
            </Header>
            <p style={{ fontSize: '1.33em' }}>
              Reach out to us anytime at homecarenuvention@gmail.com and we will set up a time to chat to talk more about our product and our mission statement. You can also 
              call or send a text at (312)-934-9963. Or just enter your email here to be part of our mailing list:
            </p>
            {/* </Grid.Column> */}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign='center'>
            <a href="//utkarshmishra2022.typeform.com/to/m7wknd" target="_blank"><Button size='huge'>Register</Button></a>
          </Grid.Column>
        </Grid.Row>
        {/* <Grid.Row>
          <Grid.Column textAlign='center'>
          <Link as='a' to={'//https://launchhomecare.carrd.co/'}><Button size='huge'>Register</Button></Link>
          </Grid.Column>
        </Grid.Row> */}
      </Grid>
    </Segment>
    {/* <Grid.Column floated='right' width={6}>
            <Image bordered rounded size='large' src='/images/wireframe/white-image.png' />
          </Grid.Column> */}


    {/* <Segment style={{ padding: '0em' }} vertical>
      <Grid celled='internally' columns='equal' stackable>
        <Grid.Row textAlign='center'>
          <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
            <Header as='h3' style={{ fontSize: '2em' }}>
              "What a Company"
            </Header>
            <p style={{ fontSize: '1.33em' }}>That is what they all say about us</p>
          </Grid.Column>
          <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
            <Header as='h3' style={{ fontSize: '2em' }}>
              "I shouldn't have gone with their competitor."
            </Header>
            <p style={{ fontSize: '1.33em' }}>
              <Image avatar src='/images/avatar/large/nan.jpg' />
              <b>Nan</b> Chief Fun Officer Acme Toys
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment> */}

    {/* <Segment style={{ padding: '8em 0em' }} vertical>
      <Container text>
        <Header as='h3' style={{ fontSize: '2em' }}>
          Breaking The Grid, Grabs Your Attention
        </Header>
        <p style={{ fontSize: '1.33em' }}>
          Instead of focusing on content creation and hard work, we have learned how to master the
          art of doing nothing by providing massive amounts of whitespace and generic content that
          can seem massive, monolithic and worth your attention.
        </p>
        <Button as='a' size='large'>
          Read More
        </Button>

        <Divider
          as='h4'
          className='header'
          horizontal
          style={{ margin: '3em 0em', textTransform: 'uppercase' }}
        >
          <a href='#'>Case Studies</a>
        </Divider>

        <Header as='h3' style={{ fontSize: '2em' }}>
          Did We Tell You About Our Bananas?
        </Header>
        <p style={{ fontSize: '1.33em' }}>
          Yes I know you probably disregarded the earlier boasts as non-sequitur filler content, but
          it's really true. It took years of gene splicing and combinatory DNA research, but our
          bananas can really dance.
        </p>
        <Button as='a' size='large'>
          I'm Still Quite Interested
        </Button>
      </Container>
    </Segment> */}

    <Segment inverted vertical style={{ padding: '5em 0em' }}>
      <Container>
        <Grid divided inverted stackable>
          <Grid.Row>
            <Grid.Column width={3}>
              <Header inverted as='h4' content='Follow us' />
              <List link inverted>
                <a href="//facebook.com/homecareapp" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Facebook</List.Item></a>
                <a href="//twitter.com/Homecare_app" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Twitter</List.Item></a>
                <a href="//instagram.com/homecare_nu" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Instagram</List.Item></a>
                {/* <Hyperlink linkStyle={{ color: '#2980b9', fontSize: 20 }}
                  <div style={{ fontSize: 15 }}>
                    Make clickable strings like https://github.com/obipawan/hyperlink stylable
    </div>
                </Hyperlink> */}

                {/* <List.Item as='a'>Gazebo Plans</List.Item> */}
              </List>
            </Grid.Column>
            <Grid.Column width={3}>
              <Header inverted as='h4' content='Contact us' />
              <List link inverted>
                <List.Item>homecarenuvention@gmail.com</List.Item>
                {/* <List.Item as='a'>How To Access</List.Item>
                <List.Item as='a'>Favorite X-Men</List.Item> */}
              </List>
            </Grid.Column>
            <Grid.Column width={7}>
              <Header as='h4' inverted>
                Homecare
              </Header>
              <p>
                Help us help you care.
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  </ResponsiveContainer>
)

export default Home;